module.exports = __webpack_public_path__ + "static/media/geotechnical_investigation_see_far1.72e91b60.jpeg";